export default "__VITE_ASSET__DAH8WSDU__"